import { DefaultRootState } from "stores";
import { TurboRoom } from "./records";

export const getTurboRoom = (
  state: DefaultRootState,
  roomId: string
): TurboRoom | null => {
  return state.entities.turboRooms?.[roomId] || null;
};

export const getTurboRoomEnabled = (
  state: DefaultRootState,
  roomId: string
): boolean => {
  const turboRoom = getTurboRoom(state, roomId);
  if (!turboRoom?.enabled) return false;

  // Check if turbo mode is expired (24 hours limit)
  if (!turboRoom.timestamp) return false;

  const timestampMs = (turboRoom.timestamp as any).seconds
    ? (turboRoom.timestamp as any).seconds * 1000
    : (turboRoom.timestamp as unknown as number);
  const now = Date.now();
  const twentyFourHours = 24 * 60 * 60 * 1000;

  return now - timestampMs <= twentyFourHours;
};

export const getAllTurboRooms = (state: DefaultRootState) => {
  return state.entities.turboRooms;
};

export const getCurrentTurboRoom = (
  state: DefaultRootState
): TurboRoom | null => {
  const roomId = state.app.state.roomId;
  if (!roomId) return null;
  return getTurboRoom(state, roomId);
};
